<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <span class="modal-title">
    New Topic {{ session.config.cluster ? 'Cluster' : '' }}
  </span>
</div>

<div class="modal-body clearfix">
  <div class="row">
    <div class="col-lg-8">
      <form [formGroup]="sessionForm">
        <div class="form-group mb-3">
          <label class="form-label" for="title">
            Topic {{ session.config.cluster ? 'Cluster ' : '' }}Title:
          </label>
          <input
            type="text"
            id="title"
            class="form-control"
            formControlName="title"
            required />
        </div>
        <div
          class="form-group mb-3"
          [ngClass]="{ 'has-error': tooLongOneLiner }">
          <label class="form-label" for="one_liner">Short Description:</label>
          <input
            type="text"
            id="oneLiner"
            class="form-control"
            formControlName="oneLiner" />
          <p class="help-text wordcount">
            {{ sessionForm.controls.oneLiner.value.length }} /
            {{ inputLengths.SESSION_ONE_LINER }} characters
          </p>
        </div>
        <div class="form-group mb-3">
          <label class="form-label" for="description">
            Detailed Description:
          </label>
          <textarea
            id="description"
            class="form-control"
            rows="5"
            formControlName="description"></textarea>
        </div>
      </form>
      <div class="alert alert-warning" *ngIf="sessionForm.invalid">
        <strong>Warning!</strong>
        You need to provide a topic name to create a new topic.
      </div>
    </div>
    <div class="col-lg-4">
      <app-image-upload
        (uploadComplete)="onUploadComplete($event)"
        (uploadStart)="onUploadStart()"
        [defaultImage]="
          'image/default_session_thumbnail.png'
        "></app-image-upload>
    </div>
  </div>
  <div class="alert alert-error" *ngIf="error">
    <strong>Error!</strong>
    Could not create the topic.
    <code>
      {{ error }}
    </code>
  </div>
</div>

<div class="modal-footer">
  <button (click)="dismiss()" class="btn btn-danger">Cancel</button>
  <button
    [disabled]="pending || sessionForm.invalid || activeUpload"
    (click)="postSession()"
    class="btn btn-primary">
    Create
  </button>
</div>
